import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
const DEFAULT_TEXT_AS = "p";
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const Text = ({ children, className, color, font, as, ...rest }) => {
    const Tag = as || DEFAULT_TEXT_AS;
    return (_jsx(Tag, { className: classNames({ [`eds-type--${font}`]: font, [`eds-color--${color}`]: color }, className), ...rest, children: children }));
};
